module.exports = __webpack_public_path__ + "static/media/step1.255d9197.png";